import { render, staticRenderFns } from "./search-index.vue?vue&type=template&id=6d4c79d2&scoped=true"
import script from "./search-index.vue?vue&type=script&lang=js"
export * from "./search-index.vue?vue&type=script&lang=js"
import style0 from "./search-index.vue?vue&type=style&index=0&id=6d4c79d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4c79d2",
  null
  
)

export default component.exports